module.exports = __webpack_public_path__ + "img/content6.a59d9ce2.png";